import { useEffect, useState } from "react";
import useConfirm from "../hooks/useConfirm";

export const ConfirmPopup = () => {
    const { confirmPopup, setConfirmPopup, data }: any = useConfirm();
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    useEffect(() => {
        if (confirmPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [confirmPopup]);

    const closeModal = () => setConfirmPopup(false);

    const confirmModal = () => {
        if (!isProcessing) {
            setIsProcessing(true);
            data?.isConfirm?.(() => {
                setIsProcessing(false);
                closeModal();
            });
        }

    };

    if (!confirmPopup) return null;

    return (
        <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full max-w-md mx-4 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex justify-end">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className="w-4 h-4 cursor-pointer fill-gray-600"
                        onClick={closeModal}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                </div>

                <div className="my-6 text-center">
                    <h4 className="text-lg font-semibold text-gray-800">
                        {data?.title}
                    </h4>
                    <p className="text-sm mt-2 text-gray-600">
                        {data?.summary}
                    </p>
                </div>

                <div className="flex justify-center gap-4 mt-6">
                    {
                        data?.isCancelBtn && (
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
                            >
                                Cancel
                            </button>
                        )
                    }

                    <button
                        onClick={confirmModal}
                        className="px-4 py-2 rounded bg-primary text-white transition"

                    >
                        {isProcessing ? "Processing..." : data?.confirmBtn || "Yes"}
                    </button>
                </div>
            </div>
        </div>
    )
}